import React from 'react';

const JOBS = [
  { title: 'Limpeza residencial', addr: 'Rua das Flores, 120', price: '85', time: 'Hoje 14:00', status: 'Disponível' },
  { title: 'Reparo elétrico', addr: 'Av. Liberdade, 45', price: '120', time: 'Amanhã 09:00', status: 'Aceito' },
  { title: 'Manutenção AC', addr: 'Praça do Comércio, 8', price: '150', time: 'Sex 16:00', status: 'Disponível' },
];

export const ScreenProvider = React.memo(() => (
  <div className="px-3 pt-2">
    <div className="flex items-center justify-between mb-3 px-1">
      <div>
        <div className="text-[10px] text-gray-400">Bem-vindo</div>
        <div className="text-sm font-semibold text-black">Carlos Santos</div>
      </div>
      <div className="w-8 h-8 rounded-full bg-black" />
    </div>
    <div className="text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-2 px-1">Próximos serviços</div>
    <div className="flex flex-col gap-2">
      {JOBS.map((j, i) => (
        <div key={i} className="bg-white border border-gray-200 rounded-xl p-2.5 shadow-sm">
          <div className="flex items-start justify-between mb-1">
            <div className="text-xs font-semibold text-black">{j.title}</div>
            <div className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${j.status === 'Aceito' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700'}`}>{j.status}</div>
          </div>
          <div className="text-[10px] text-gray-500 mb-1.5">{j.addr}</div>
          <div className="flex items-center justify-between">
            <div className="text-[10px] text-gray-400">{j.time}</div>
            <div className="text-xs font-bold text-black">€{j.price}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
));
ScreenProvider.displayName = 'ScreenProvider';
